<nav class="navbar navbar-dark sticky-top navbar-expand-sm bg-brand shadow">
    <ul class="navbar-nav">
        <li>
             <surescripts-product-dropdown [dataUrl]="productDropdownUrl"></surescripts-product-dropdown>
        </li>
    </ul>
    <a class="navbar-brand" id="home-link" title="Workbench Dashboard" [routerLink]="['/products']">Surescripts Workbench</a>
    <div class="collapse navbar-collapse"></div>
    <ul class="navbar-nav">
        <li *ngIf="showCpiHelp" class="nav-item">
            <a [routerLink]="[helpUrl]" target="_blank" class="nav-link"><fa-icon [icon]="['far', 'question-circle']" size="lg"></fa-icon></a>
        </li>
        <li class="nav-item">
            <surescripts-notifications [baseDataUrl]="notificationsUrl"></surescripts-notifications>
        </li>
        <li class="nav-item">
            <surescripts-user-profile logoutUrl="account/logout" [dataUrl]="userProfileUrl"></surescripts-user-profile>
        </li>
    </ul>
</nav>
